import { useQuery } from '@tanstack/react-query';

import { AgentChatType, CHAT_CONFIG } from '@/constant/chatConfig';
import { SESSIONS_QUERY_OPTIONS } from '@/store/sessions';

// Query session history for an agent chat.
export const useChatSessionHistory = (
  chatType: AgentChatType,
  sessionId?: string,
  enabled = true
) =>
  useQuery({
    queryKey: [
      CHAT_CONFIG[chatType].historyQueryKey,
      { sessionId: sessionId ?? '' },
    ],
    queryFn: () =>
      sessionId
        ? CHAT_CONFIG[chatType].historyFetcher(sessionId)
        : Promise.resolve(undefined),
    ...SESSIONS_QUERY_OPTIONS,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!sessionId && enabled,
  });
